/// <amd-module name="WorkItemsHub/Utils/WorkItemTempQueryUtils" />
import * as Resources from "WorkItemsHub/Resources";
import { getQueriesHubUrl } from "WorkItemsHub/Utils/UrlUtils";
import { IVssPageContext } from "VSS/Platform/Context";

export namespace WorkItemTempQueryUtils {
    /**
     * Creates a URL for the specified temp query ID
     * @param pageContext Page context
     * @param projectName Project name
     * @param tempQueryId ID of the temp query
     * @returns URL for the specified temp query ID
     */
    export function createTempQueryUrl(pageContext: IVssPageContext, projectName: string, tempQueryId: string): string {
        return getQueriesHubUrl(pageContext, projectName, tempQueryId);
    }
}
